import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { compose } from 'redux';
import { withTheme } from '@material-ui/core/styles';
import HOCLoader from '../../components/HOC/HOCLoader.jsx';
import profilePageStyle from 'assets/jss/material-kit-react/views/profilePage.jsx';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import Detail from '../../components/Providers/Detail.js';
import { Redirect } from 'react-router-dom';

class ProviderDetail extends React.Component {
    constructor(props) {
        super();
        if (props.match.params) {
            this.state = {
                backRedirect: false,
                providerId: props.match.params.providerId,
                serviceId: props.match.params.serviceId,
                loader: true,
                noResponse: false
            };
        } else {
            this.state = {
                backRedirect: true,
                providerId: '',
                serviceId: '',
                loader: true,
                noResponse: false
            };
        }
    }
    componentDidMount() {
        this.getData(this.state.providerId, this.state.serviceId);
        this.props.getWishlistAction();
    }
    getData = (providerId, serviceId) => {
        this.setState({ loader: true });
        this.props.providerDetailAction(
            {
                providerId: providerId,
                serviceId: serviceId,
                day: new Date().getDay()
            },
            this.onDone
        );
    };

    onDone = (success, data) => {
        if (success) {
            this.setState({ detailData: data, loader: false });
        } else {
            this.setState({ loader: false, error: data, noResponse: true });
        }
    };
    refreshData = (proId, serviceId) => {
        this.props.history.push({
            pathname: `/provider/detail/${proId}/${serviceId}`,
            state: {
                providerId: proId,
                serviceId: serviceId
            }
        });
        this.getData(proId, serviceId);
    };
    render() {
        const { wishListData, wishlistLoader } = this.props;

        if (this.state.backRedirect) {
            return <Redirect to={'/'} />;
        }
        return (
            <HOCLoader
                loading={this.state.loader}
                noResponse={this.state.noResponse}
                errorShow={this.state.error}
            >
                <Detail
                    providerId={this.state.providerId}
                    serviceId={this.state.serviceId}
                    data={this.state.detailData}
                    refreshData={this.refreshData}
                    afterLoginUrl={`/book/service/${this.state.providerId}/${
                        this.state.serviceId
                    }`}
                    wishListData={wishListData}
                    wishlistLoader={wishlistLoader}
                />
            </HOCLoader>
        );
    }
}
const mapStateToProps = ({ auth }) => {
    return {
        wishListData: auth.wishlistData,
        wishlistLoader: auth.wishlistLoader
    };
};
const composedComponent = compose(
    withTheme(),
    withStyles(profilePageStyle),
    connect(
        mapStateToProps,
        actions
    )
);
export default composedComponent(ProviderDetail);



// WEBPACK FOOTER //
// ./src/views/User/ProviderDetail.jsx